import styled from 'styled-components';

import { Waves } from '~/src/common/components/Logo';
import { media } from '~/src/styles-constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.common.POSITIVE_LIGHT};
  padding-top: 24px;
  padding-bottom: 24px;
  margin-top: 40px;
  ${media.M`
    margin-top: 64px;
    padding-top: 56px;
    padding-bottom: 56px;
  `}
`;

export const StyledWaves = styled(Waves)`
  width: 95px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;

  > span {
    margin-top: 8px;
    color: ${({ theme }) => theme.palette.common.PITAYA};
    line-height: 40px;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-weight: 700;
    font-size: 32px;
    ${media.M`
      margin-top: 16px;
      font-size: 44px;
  `}
  }
  ${media.M`
      margin-bottom: 32px;
  `}
`;
